
/// used as a bridge for ant.design binding
import { Input } from 'antd'

export { Icon } from '@ant-design/compatible';

export const InputGroup = Input.Group

export const TextArea = Input.TextArea